import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { DialogForceConnectionData } from './models/dialog-force-connection-data';

@Component({
    selector: 'app-force-connection',
    templateUrl: './force-connection.component.html',
    styleUrls: ['./force-connection.component.scss'],
    imports: [MatCardModule, MatButtonModule, MatDialogClose]
})
export class ForceConnectionComponent {
    /**
     * Constructeur.
     * @param dialogRef
     */
    constructor(
        public dialogRef: MatDialogRef<ForceConnectionComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogForceConnectionData
    ) {}
}
